import { environment } from 'src/environments/environment';

/**
 * Base del API REST de TPV (`api/v1/tpv/`).
 *
 * Usa `environment.tpvApiUrl` si está definido; si no, lo deriva de
 * `environment.apiUrl` (`${apiUrl}/api/v1/tpv`). Nunca incluye `/` final.
 */
export function tpvApiBase(): string {
  const explicit = (environment.tpvApiUrl ?? '').trim();
  if (explicit) return explicit.replace(/\/+$/, '');
  const root = (environment.apiUrl ?? '').replace(/\/+$/, '');
  return `${root}/api/v1/tpv`;
}

/** Arma una URL absoluta de TPV a partir de un path relativo (ej. 'merchants/'). */
export function tpvUrl(path: string): string {
  const clean = path.replace(/^\/+/, '');
  return `${tpvApiBase()}/${clean}`;
}

/**
 * Toggle de migración: `true` usa el REST nuevo; `false`/ausente mantiene el
 * gateway GraphQL legado. Ver TPV_MIGRATION.md (Strangler Fig).
 */
export function isTpvRestEnabled(): boolean {
  return environment.tpvRestApi === true;
}

/** En dev, sirve datos mock en vez de pegarle al backend real. */
export function isTpvMockEnabled(): boolean {
  return environment.tpvUseMocks === true;
}
